import React from 'react';

const TierDetails = ({ tier, tierListe, index }) => {

    const floatClass = index % 2 === 0 ? "float-lg-start" : "float-lg-end";

    const scrollToParent = (parent) => {
        if (parent) {
            const element = document.getElementById(parent.id);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    };

    return (
        <div id={tier.id} className="randBox">
            <div style={{ backgroundImage: `url(${tier.bild})` }} className={`about-image ${floatClass} mx-auto mx-lg-5`} />
            <div>
                <h2>{tier.name}</h2>
                <p><strong>Farbe:</strong> {tier.farbe}</p>
                <p><strong>Beschreibung:</strong> {tier.text}</p>

            </div>
            
        </div>
    );
};

export default TierDetails;
